import { useEffect } from "react";

export default function HomeSEO() {
  useEffect(() => {
    document.title = "17c每日大赛 - 每天参赛赢好礼 | 17c竞技互动平台";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "17c每日大赛是专为用户打造的每日竞技互动平台，每天开启全新赛事，轻松参赛、丰厚奖励等你来拿。加入17c每日大赛，与万千玩家同台竞技，享受每日挑战乐趣，错过今天还有明天，天天有惊喜！");
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", "17c每日大赛,17c大赛报名,每日大赛活动,17c竞技平台,每天参赛赢奖励,17c赛事攻略,每日挑战赛");
    }

    const existingScript = document.getElementById("home-schema");
    if (existingScript) existingScript.remove();

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "name": "17c每日大赛",
          "url": window.location.origin + (window.__BASE_PATH__ || ""),
          "description": "17c每日大赛是专为用户打造的每日竞技互动平台",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "400-888-1717",
            "contactType": "customer service",
            "availableLanguage": "Chinese",
          },
        },
        {
          "@type": "WebSite",
          "name": "17c每日大赛",
          "url": window.location.origin + (window.__BASE_PATH__ || ""),
          "potentialAction": {
            "@type": "SearchAction",
            "target": window.location.origin + (window.__BASE_PATH__ || "") + "/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@type": "WebPage",
          "name": "17c每日大赛 - 首页",
          "url": window.location.origin + (window.__BASE_PATH__ || ""),
          "description": "17c每日大赛官方网站首页，了解最新赛事活动和竞技资讯",
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "17c每日大赛是完全免费的吗？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "是的！17c每日大赛对所有用户完全免费开放。",
              },
            },
            {
              "@type": "Question",
              "name": "每天可以参加几场赛事？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "每天最多可以参加10场正式赛事，建议选择2-3场最适合自己的赛事认真参与。",
              },
            },
            {
              "@type": "Question",
              "name": "获得的奖励如何领取？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "实物奖品3个工作日内确认地址，7个工作日内发货；虚拟奖励即时发放；现金红包24小时内到账。",
              },
            },
            {
              "@type": "Question",
              "name": "如果错过了今天的赛事怎么办？",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "17c每日大赛的核心理念就是「错过今天还有明天」，每天都会有全新的赛事开放。",
              },
            },
          ],
        },
      ],
    };

    const script = document.createElement("script");
    script.id = "home-schema";
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById("home-schema");
      if (el) el.remove();
    };
  }, []);

  return null;
}